// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ActiveStatus } from './active-status';
import { PricedProductType } from './priced-product-type';
import { ProductTypeConfigAddon } from './product-type-config-addon';
import { ProductTypeConfigProduct } from './product-type-config-product';
import { ProgramProductTypeConfig } from './program-product-type-config';
import { ReturnPolicy } from './return-policy';
import { ActiveStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags
import * as _ from 'lodash';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProductTypeConfig extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  lookupPrices() {
    this.productTypeConfigProducts.forEach((ptcp) => ptcp.lookupPrices());
  }

  // Next 2 methods all require that queries to populate all navigations have been made.
  getBasePrice() {
    return this.isInventory ? this.pricedProductType.inventoryPrice : this.pricedProductType.basePrice;
  }

  getAddonsPrice() {
    const ptcAddons = this.productTypeConfigAddons;
    if (ptcAddons.length == 0) return 0;
    const useInventory = this.isInventory;
    const addonsPrice = _.sum(ptcAddons.map((ptca) => useInventory ? ptca.pricedAddon.inventoryPrice : ptca.pricedAddon.price));
    return addonsPrice;
  }

  getStatusParents() {
    return [this.pricedProductType];
  }

  getStatusId() {
    return this.activeStatusId;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Enum FK activeStatus */
  activeStatusId!: ActiveStatusEnum;
  /** Boolean */
  isInventory!: boolean;
  /** String(60) */
  name!: string;
  /** Guid FK pricedProductType */
  pricedProductTypeId!: string;
  /** Guid FK returnPolicy */
  returnPolicyId?: string;
  /** Binary */
  rowVersion!: any;
  /** FK activeStatusId */
  activeStatus!: ActiveStatus;
  /** FK pricedProductTypeId */
  pricedProductType!: PricedProductType;
  /** Inv FK productTypeConfigId */
  productTypeConfigAddons!: ProductTypeConfigAddon[];
  /** Inv FK productTypeConfigId */
  productTypeConfigProducts!: ProductTypeConfigProduct[];
  /** Inv FK productTypeConfigId */
  programProductTypeConfigs!: ProgramProductTypeConfig[];
  /** FK returnPolicyId */
  returnPolicy!: ReturnPolicy;
}

